<template>
  <AbaDownload :titulo="titulo" v-if="!loading">
    <TabelaDownload
      v-if="qtTotal > 0"
      @baixar-todos="baixarTodos"
      @baixar-selecionados="baixarSelecionados"
      @baixar="baixar"
      @input="v => (checkbox = v)"
      :checkbox="checkbox"
      :loadings="loadings"
      :qtTotal="qtTotal"
      :pagina="pagina"
      :qtPaginas="qtPaginas"
      :rows="rows"
      :exibirBotaoPaginacao="false"
    />
  </AbaDownload>
  <unicom-spinner
    v-else
    style="
      min-height: 450px;
      display: flex;
      flex-flow: wrap column;
      justify-content: center;
    "
    :tamanhoLoading="62"
    :tamanhoLinha="7"
    :velocidade="0.5"
    :marginTopTexto="30"
    mensagem="Carregando..."
  />
</template>

<script>
import AbasMixin from "../AbasMixin";
import AbaDownloadMixin from "../AbaDownloadMixin";

export default {
  mixins: [AbasMixin, AbaDownloadMixin],
  data() {
    let arr = [];

    return {
      checkbox: [],
      downloads: [],
      loadings: [],
      qtTotal: 0,
      pagina: 1,
      qtPaginas: 1,
      rows: [],
      loading: false,
      arrMock: arr
    };
  },
  activated() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      this.resetarVariaveis();
      this.sleep(500).finally(() => {
        this.inicializarTabela();
      });
    },
    resetarVariaveis() {
      this.checkbox = [];
      this.downloads = [];
      this.loadings = [];
    },
    inicializarTabela() {
      this.loading = true;
      this.rows = [];

      this.getArquivosRedeNacionalPrestador(this.computedFilter)
        .then(res => {
          const lista = res.data;

          lista.forEach(e => {
            const { id, nomeArquivo, data } = e;

            this.rows.push({
              id,
              nomeArquivo,
              data: this.$helpers.formatadorHorario(data)
            });
          });

          this.qtTotal = lista.length;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    baixarTodos() {
      this.$store.commit("setLoadingModal", true);
      this.getDownloadTodosRedeNacionalPrestador()
        .then(res => {
          if (res.status === 204) return;
          this.$helpers.baixarArquivo(
            res.data,
            res.headers["content-disposition"]
          );
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });
    },
    baixarSelecionados() {
      this.$store.commit("setLoadingModal", true);
      this.getDownloadSelecionadosRedeNacionalPrestador({
        ...this.computedFilter,
        tipos: this.checkbox
      })
        .then(res => {
          if (res.status === 204) return;
          this.$helpers.baixarArquivo(
            res.data,
            res.headers["content-disposition"]
          );
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });

      this.checkbox = [];
    },
    baixar(id) {
      if (!this.downloads.includes(id)) {
        this.downloads.push(id);
      }

      this.atualizarLoading(id, 0);

      this.sleep(100).finally(() => {
        this.getDownloadSelecionadosRedeNacionalPrestador(
          { tipos: [id] },
          {
            onDownloadProgress: progressEvent => {
              let porcentagem = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );

              this.atualizarLoading(id, porcentagem);

              if (porcentagem === 100) {
                this.sleep(300).finally(() => {
                  this.atualizarLoading(id, 101);
                });
              }
            }
          }
        )
          .then(res => {
            if (res.status === 204) return;
            this.$helpers.baixarArquivo(
              res.data,
              res.headers["content-disposition"]
            );
          })
          .catch(() => {
            this.atualizarLoading(id, -1);
          });
      });
    },
    atualizarLoading(id, valor) {
      this.$set(this.loadings, id, valor);
    }
  },
  computed: {
    textoSubtitulo() {
      const { descricaoPrestador, competencia } = this.objetoFiltro;

      if (!competencia) {
        return `${this.letraMaiusculaCadaPalavra(descricaoPrestador)}`;
      }

      return `${this.letraMaiusculaCadaPalavra(
        descricaoPrestador
      )}, ${this.$helpers.formatadorData(competencia, "MMMM [de] YYYY")}.`;
    }
  }
};
</script>

<style></style>
